<script>
  import { fade } from "svelte/transition";
  import { user, auth } from "../firebase";
  import { baseAPIUrl } from "../globals";
  import { authenticatedFetch } from "../appbridge";
  import { router } from "tinro";
  import { signOut } from "firebase/auth";
  import { conversion, lang } from "../store/store";

  import MaterialSpinner from "../components/MaterialSpinner.svelte";
  import {
    updateProfile,
    signInWithEmailAndPassword,
    createUserWithEmailAndPassword,
  } from "firebase/auth";
  import { each } from "svelte/internal";

  // import AdditionalInformation from "../components/AdditionalInformation.svelte";
  $: console.log(load);
  let bgappear = false;
  let load = false;
  let errorArray = [];
  const emailExpression =
    /^[a-zA-Z0-9]{4,11}[._-]{0,1}[a-zA-Z0-9]{1,11}[@]{1}[a-zA-Z]{3,15}[.]{1}[a-zA-Z]{2,6}$/g;

  let firstNameInput;
  let lastname;
  let emailInput;
  let passwordInput;
  let ConfirmpasswordInput;
  let phone;
  let shopDomain;
  let errors = {
    firstname: {
      error: false,
      message: "First name must be between 3 and 16 characters",
    },
    lastname: {
      error: false,
      message: "Last name must be between 3 and 16 characters",
    },
    email: {
      error: false,
      message: "Invalid E-mail",
    },
    password: {
      error: false,
      message: "Password must be longer than 7 characters",
    },
    confirmpassword: {
      error: false,
      message: "Second password is wrong",
    },
    phonenumber: {
      error: false,
      message: "Phone number should be country code and number",
    },
    shopname: {
      error: false,
      message:
        "Shop name should have atleast a '.' and longer than 8 characters",
    },
    customError: {
      error: false,
      message: "",
    },
  };

  let locale = "fr";
  $: if (locale) {
    $lang = locale;
  }
  let languageOptions = [
    {
      name: "French",
      value: "fr",
    },
    {
      name: "English",
      value: "en",
    },
  ];
  let answer = "";

  const doLogin = async () => {
    let resp = await fetch(baseAPIUrl + "/firebase/register", {
      method: "POST",
      body: JSON.stringify({
        email: emailInput.value,
        firstname: firstNameInput.value,
        lastname: lastname.value,
        password: passwordInput.value,
        phone: phone.value,
        locale: locale,
        shopDomain: shopDomain.value,
      }),
      mode: "cors",
      headers: {
        "X-Requested-With": "firebase",
      },
    }).then((resp) => {
      return resp.json();
    });
    load = false;

    console.log(resp);
    if (resp.success) {
      router.goto("/login");
      return;
    }

    if (!resp.success) {
      if (resp?.error?.code?.includes("phone")) {
        errors.phonenumber.message = resp.error.message;
        errors.phonenumber.error = true;
      }
      if (resp?.error?.code == "auth/email-already-in-use") {
        errors.email.message = resp.error.message;
        errors.email.error = true;
      }
      if (
        resp?.error?.code == "clickup/domain-slug-exist" ||
        resp?.error?.code == "firestore/domain-slug-exist"
      ) {
        errors.shopname.message = resp.error.message;
        errors.shopname.error = true;
      }
    }

    return;
    let response = await fetch(baseAPIUrl + "/checkShopDomain", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        shopDomain: shopDomain.value,
      }),
    }).then((response) => {
      return response.json();
    });
    console.log("///////////////////");
    console.log("Server response");
    console.log(response);
    if (response.message == "shopdomain already set up") {
      errors.shopname.error = true;
      errors.shopname.message = "This shop domain is already taken";
      load = false;
      return;
    }
    createUserWithEmailAndPassword(auth, emailInput.value, passwordInput.value)
      .then(async (userCredential) => {
        updateProfile(auth.currentUser, {
          displayName: shopDomain.value,
        });
        load = true;
        console.log(userCredential);
        const user = userCredential.user;
        const token = await user.getIdToken();
        console.log({ with: "firebase", token });
        console.log("here");

        let resp = await fetch(baseAPIUrl + "/clickup/initFirebaseUser", {
          method: "POST",
          body: JSON.stringify({
            email: emailInput.value,
            firstname: firstNameInput.value,
            lastname: lastname.value,
            password: passwordInput.value,
            phone: phone.value,
            locale: locale,
            shopDomain: shopDomain.value,
          }),
          mode: "cors",
          headers: {
            Authorization: "Bearer " + token,
            "X-Requested-With": "firebase",
          },
        }).then((resp) => {
          return resp.json();
        });

        window.location.assign("/");
        load = false;
        console.log("I've reached here");
        console.log("REDIRECTED");
      })
      .catch((error) => {
        console.log(JSON.stringify(error));
        if (error.code == "auth/email-already-in-use") {
          errors.email.message = "This e-mail is already in use";
          errors.email.error = true;
        }
        load = false;
      });
  };

  function errorHandler() {
    errorArray = [];
    errors.email.error = false;
    errors.email.message = "Invalid E-mail";
    errors.shopname.error = false;
    errors.shopname.message = "Shop name should have [slug].myshopify.com";
    load = true;
    console.log(firstNameInput.value);
    if (!/^[a-zA-Z]{3,16}$/g.test(String(firstNameInput.value))) {
      errors.firstname.error = true;
      load = false;
      return;
    }
    console.log(errors.firstname.error);
    errors.firstname.error = false;

    if (!/^[a-zA-Z]{3,16}$/g.test(String(firstNameInput.value))) {
      errors.lastname.error = true;
      load = false;
      return;
    }

    errors.lastname.error = false;
    console.log("email");
    console.log(emailExpression.test(String(emailInput.value)));
    if (emailExpression.test(String(emailInput.value))) {
      errors.email.error = true;
      load = false;
      return;
    }

    errors.email.error = false;

    if (passwordInput.value.length < 7) {
      errors.password.error = true;
      load = false;
      return;
    }

    errors.password.error = false;

    if (passwordInput.value != ConfirmpasswordInput.value) {
      errors.confirmpassword.error = true;
      load = false;
      return;
    }

    errors.confirmpassword.error = false;
    console.log("phone");
    console.log(/^\+?[1-9]\d{1,14}$/g.test(phone.value.split(" ").join("")));

    if (!/^\+[1-9]\d{1,14}$/g.test(phone.value.split(" ").join(""))) {
      errors.phonenumber.error = true;
      load = false;
      return;
    }

    errors.phonenumber.error = false;

    if (
      !/^(http(s)?:\/\/)?[a-zA-Z0-9-]{3,}[.]{1}myshopify.com{1}$/g.test(
        shopDomain.value
      )
    ) {
      errors.shopname.error = true;
      load = false;
      return;
    }

    errors.shopname.error = false;

    doLogin();
  }
</script>

<!-- {#if bgappear}
    ADDITIONAL INFORMATIONS
    <div transition:fade={{ duration: 300 }} class="bleuBackground">
        <div class="mainContent">
            <div class="iconwrapper">
                <i on:click={doSignup} class="bx bx-x" />
            </div>
            <div class="header">
                <h3>Additional Information</h3>
                <div class="icon" />
            </div>
            <div class="secondary-content">
                <form>
                    <label>Your Website domain name</label>
                    <input type="email" placeholder="you@exemple.com" />
                    <label>Phone Number</label>
                    <input type="tel" placeholder="Password" />

                    <label>Prefered Language</label>
                    <input type="text" placeholder="English" />

                    <div class="buttonContainer">
                        <button type="submit">Sign in</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
{/if} -->

<div
  class="contentWrapper"
  in:fade={{ duration: 300, delay: 300 }}
  out:fade={{ duration: 300, delay: 0 }}
>
  <div class="mainContent">
    <div class="imageContainer"><img src="./images/icon.png" alt="" /></div>
    <h3>{$conversion[$lang].SignUpPage[1]}</h3>

    <div class="secondary-content">
      <form on:submit|preventDefault={errorHandler}>
        <input
          class:err={errors.firstname.error}
          required
          bind:this={firstNameInput}
          type="text"
          placeholder={$conversion[$lang].SignUpPage[2]}
        />
        {#if errors.firstname.error}
          <div class="error-container">{errors.firstname.message}</div>
        {/if}
        <input
          class:err={errors.lastname.error}
          required
          bind:this={lastname}
          type="text"
          placeholder={$conversion[$lang].SignUpPage[3]}
        />
        {#if errors.lastname.error}
          <div class="error-container">{errors.lastname.message}</div>
        {/if}
        <input
          class:err={errors.email.error}
          required
          bind:this={emailInput}
          type="email"
          placeholder="you@exemple.com"
        />
        {#if errors.email.error}
          <div class="error-container">{errors.email.message}</div>
        {/if}
        <input
          class:err={errors.password.error}
          bind:this={passwordInput}
          type="password"
          placeholder={$conversion[$lang].SignUpPage[4]}
        />

        {#if errors.password.error}
          <div class="error-container">{errors.password.message}</div>
        {/if}

        <input
          class:err={errors.confirmpassword.error}
          bind:this={ConfirmpasswordInput}
          type="password"
          placeholder={$conversion[$lang].SignUpPage[5]}
        />

        {#if errors.confirmpassword.error}
          <div class="error-container">{errors.confirmpassword.message}</div>
        {/if}
        <input
          class:err={errors.phonenumber.error}
          required
          bind:this={phone}
          type="text"
          placeholder={$conversion[$lang].SignUpPage[6]}
        />

        {#if errors.phonenumber.error}
          <div class="error-container">{errors.phonenumber.message}</div>
        {/if}

        <select class="LanguageInput" bind:value={locale}>
          {#each languageOptions as option}
            <option value={option.value}>{option.name}</option>
          {/each}
        </select>
        <input
          class:err={errors.shopname.error}
          required
          bind:this={shopDomain}
          type="text"
          placeholder="name.myshopify.com"
        />

        {#if errors.shopname.error}
          <div class="error-container">{errors.shopname.message}</div>
        {/if}

        {#if errors.customError.error}
          <div class="error-container">{errors.customError.message}</div>
        {/if}
        <h6>
          {$conversion[$lang].SignUpPage[8]}
          <span><a href="/login">{$conversion[$lang].SignUpPage[9]} </a></span>
        </h6>

        <div class="buttonContainer">
          <button disabled={load} type="submit" class="submitButton">
            {#if load}
              <MaterialSpinner height="13px" width="13px" />
            {:else}{$conversion[$lang].SignUpPage[10]}{/if}
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
<!-- {#if bgappear}
    ADDITIONAL INFORMATIONS
    <div transition:fade={{ duration: 300 }} class="bleuBackground">
        <div class="mainContent">
            <div class="iconwrapper">
                <i on:click={doSignup} class="bx bx-x" />
            </div>
            <div class="header">
                <h3>Additional Information</h3>
                <div class="icon" />
            </div>
            <div class="secondary-content">
                <form>
                    <label>Your Website domain name</label>
                    <input type="email" placeholder="you@exemple.com" />
                    <label>Phone Number</label>
                    <input type="tel" placeholder="Password" />

                    <label>Prefered Language</label>
                    <input type="text" placeholder="English" />

                    <div class="buttonContainer">
                        <button type="submit">Sign in</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
{/if} -->

<!-- AMINE WORK -->

<!-- 
<div
  class="contentWrapper"
  in:fade={{ duration: 300, delay: 300 }}
  out:fade={{ duration: 300, delay: 0 }}>
  <div class="mainContent">
    <div class="imageContainer"><img src="./images/icon.png" alt="" /></div>
    <h3>{$conversion[$lang].SignUpPage[1]}</h3>

    <div class="secondary-content">
      <form on:submit|preventDefault={errorHandler}>
        <input
          required
          bind:this={firstNameInput}
          type="text"
          placeholder={$conversion[$lang].SignUpPage[2]} />
        <input
          required
          bind:this={lastname}
          type="text"
          placeholder={$conversion[$lang].SignUpPage[3]} />
        <input
          required
          bind:this={emailInput}
          type="email"
          placeholder="you@exemple.com" />
        <input
          class={shortpasswordError == true ? 'inputError' : ''}
          bind:this={passwordInput}
          type="password"
          placeholder={$conversion[$lang].SignUpPage[4]} />
        {#if shortpasswordError}
          <div class="errorItem">
            <i class="bx bxs-error-circle" />
            <h5>Password too short</h5>
          </div>
        {/if}
        <input
          class={confirmPassword == true ? 'inputError' : ''}
          bind:this={ConfirmpasswordInput}
          type="password"
          placeholder={$conversion[$lang].SignUpPage[5]} />
        {#if confirmPassword}
          <div class="errorItem">
            <i class="bx bxs-error-circle" />
            <h5>Wrong password confirmation</h5>
          </div>
        {/if}
        <input
          required
          bind:this={phone}
          type="text"
          placeholder={$conversion[$lang].SignUpPage[6]} />
        <select class="LanguageInput" bind:value={locale}>
          
          {#each languageOptions as option}
            <option value={option.value}>{option.name}</option>
          {/each}
        </select>
        <input
          required
          bind:this={shopDomain}
          type="text"
          placeholder={$conversion[$lang].SignUpPage[7]} />
        <h6>
          {$conversion[$lang].SignUpPage[8]}
          <span><a href="/login">{$conversion[$lang].SignUpPage[9]} </a></span>
        </h6>

        <div class="buttonContainer">
          <button disabled={load} type="submit" class="submitButton">
            {#if load}
              <MaterialSpinner height="13px" width="13px" />
            {:else}{$conversion[$lang].SignUpPage[10]}{/if}
          </button>
        </div>
      </form>
    </div>
  </div>
</div> -->
<style>
  /* .u-view {
      min-height: 100vh;
      width: 100%;
      display: flex;
  }
  .u-box {
      margin: auto;
  } */

  * {
    padding: 0;
    margin: 0;
  }

  .error-container {
    color: #e6107b;
    margin-bottom: 0.6rem;
    font-size: 0.8em;
  }

  .contentWrapper {
    height: 100vh;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .mainContent {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 2rem;
    background-color: white;
    max-width: 30rem;
    box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.05);
    border-radius: 8px;
  }

  .imageContainer {
    display: flex;
    justify-content: center;
  }

  .imageContainer img {
    width: 30%;
    margin-bottom: 1rem;
  }

  .mainContent h3 {
    margin-bottom: 2rem;
    font-size: 1.8em;
    font-weight: 600;
    text-align: center;
  }

  .secondary-content {
    display: flex;
    flex-direction: column;
    /* align-items: center; */
    width: 80%;
  }

  input {
    width: 100%;
    padding: 0.5rem 1rem 0.5rem 1rem;
    background-color: #ffffff;
    border: 1px solid #c3cad9;
    border-radius: 6px;
    color: #183b56;
    margin-bottom: 1rem;
    font-size: 0.8em;
  }

  .err {
    border: 1px solid #e6107b;
    background-color: #fff2f9;
    color: #e6107b;
  }

  .inputError {
    width: 100%;
    padding: 0.5rem 1rem 0.5rem 1rem;
    background-color: #ffffff;
    border: 1px solid red;
    border-radius: 6px;
    color: #183b56;
    margin-bottom: 1rem;
    font-size: 0.8em;
  }

  .secondary-content h6 {
    font-weight: 500;
    color: rgba(149, 158, 173, 1);
    margin-bottom: 0.3rem;
  }

  .secondary-content a {
    font-weight: 500;
    color: rgba(11, 143, 251, 1);
  }

  .buttonContainer {
    margin-top: 1rem;
    display: flex;
    justify-content: center;
  }

  .buttonContainer button {
    font-size: 0.8em;
    padding: 0.5rem 2rem 0.5rem 2rem;
    background-color: #2c8f73;
    color: white;
    border-radius: 8px;
    min-width: 7.5rem;
  }

  .buttonContainer {
    margin-top: 1rem;
    display: flex;
    justify-content: center;
  }

  .buttonContainer button {
    font-size: 0.8em;
    padding: 0.5rem 2rem 0.5rem 2rem;
    background-color: #2c8f73;
    color: white;
    border-radius: 8px;
  }

  .LanguageInput {
    width: 100%;
    padding: 0.5rem 1rem 0.5rem 1rem;
    background-color: #ffffff;
    border: 1px solid #c3cad9;
    border-radius: 6px;
    color: #183b56;
    margin-bottom: 1rem;
    font-size: 0.8em;
  }

  .error {
    background-color: rgb(255, 108, 108);
    margin-bottom: 8px;
    color: white;
    padding: 8px;
  }

  .errorItem {
    display: flex;
    align-items: center;
    justify-content: start;
    margin-left: 0.5rem;
    margin-bottom: 1rem;
  }

  .errorItem i {
    font-weight: 900;
    margin-right: 0.5rem;
  }

  @media only screen and (max-width: 1100px) {
    .secondary-content {
      width: 100%;
    }

    .mainContent {
      text-align: center;
    }
  }
  /* ---- */
</style>
